module Visonum.BulkPingApp.Views.TextInput
  ( Props
  , defaultProps
  , view
  ) where

import Visonum.BulkPingApp.Prelude

import Data.Maybe (Maybe(..))
import Data.String as Str
import Halogen.HTML.Elements as H
import Halogen.HTML.Events (onValueInput)
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties (InputType(..))
import Halogen.HTML.Properties as P
import Web.UIEvent.KeyboardEvent (key)
import Web.UIEvent.KeyboardEvent as KE
import Web.UIEvent.KeyboardEvent.EventTypes as KET

type Props a =
  { label :: String
  , value :: String
  , onChange :: String -> a
  , multiline :: Boolean
  , password :: Boolean
  , onEnter :: Maybe a
  }

defaultProps :: Props Unit
defaultProps =
  { label: ""
  , value: ""
  , onChange: \_ -> unit
  , multiline: false
  , password: false
  , onEnter: Nothing
  }

view :: forall w a. Props a -> AppHTML w a
view props =
  let
    elRoot = styleNode H.div
      "TextInput"
      [ inline
          { width: "100%"
          , display: "grid"
          , gridTemplateColumns: "2fr 3fr"
          , gridTemplateRows: "15px auto"
          , gridTemplateAreas: Str.joinWith " "
              [ "\"Label ErrorText\""
              , "\"Input Input    \""
              ]
          , padding: "2px"
          , gap: "2px"
          , height: "100%"
          }
      ]

    elLabel = styleNode H.label
      "Label"
      [ inline
          { gridArea: "Label"
          , margin: "1px"
          , fontSize: "10px"
          , fontFamily: "Arial"
          , fontWeight: "bold"
          }
      ]

    elErrorText = styleNode H.div
      "ErrorText"
      [ inline
          { gridArea: "ErrorText"
          , margin: "1px"
          , fontSize: "10px"
          , fontFamily: "Arial"
          , textAlign: "right"
          , color: "red"
          }
      ]

    elInput = styleLeaf H.input
      "Input"
      [ inline
          { gridArea: "Input"
          , margin: "1px"
          , border: "1px solid #ccc"
          , height: "25px"
          , padding: "5px"
          , borderRadius: "5px"
          , fontSize: "12px"
          }
      ]

    elTextArea = styleLeaf H.textarea
      "Input"
      [ inline
          { gridArea: "Input"
          , margin: "1px"
          , border: "1px solid #ccc"
          , padding: "5px"
          , borderRadius: "5px"
          , fontSize: "10px"
          , lineHeight: "15px"
          }
      ]
  in
    elRoot []
      [ elLabel [] [ text props.label ]
      , elErrorText [] []
      , if props.multiline then elTextArea
          [ P.value props.value
          , onValueInput $ \val -> props.onChange val
          ]
        else
          elInput
            [ P.value props.value
            , P.type_ $ if props.password then InputPassword else InputText
            , onValueInput $ \val -> props.onChange val
            , HE.handler' KET.keydown
                ( \ev -> do
                    keyEvent <- KE.fromEvent ev
                    action <- props.onEnter
                    if key keyEvent == "Enter" then (Just action) else Nothing
                )
            ]
      ]